//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const InvokeBulkIncludeSegment: FeatureFlag = {"Id":"InvokeBulkIncludeSegment","Label":"[10.20]Include workflow segment in bulk invoke payload","Impact":"When enabled, frontend bulk invoke requests include the active segment id so traces can resolve segment_name.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
